export function mergeProps(defaultProps, props) {
    const newObj = { ...defaultProps };
    for (const k in props) {
        if (props[k] !== undefined) {
            newObj[k] = props[k];
        }
    }
    return newObj;
}
//# sourceMappingURL=merge-props.js.map